export const createScale = (newValue, oldValue) => {
  return newValue / (oldValue || 1);
};

export const applyScale = (oldValue, scale) => {
  return (oldValue || 1) * scale;
};

export const ensureScale = scale => (scale < 0 ? 0 : scale);
